var Tree = require('../hierarchy/frResultTree'),
    PageResult = require('./PageResult'),
    PageSearchResult = require('./PageSearchResult');



var PageTree = function( root ) {

    Tree.apply( this, arguments );

};


PageTree.prototype = Object.create( Tree.prototype );
PageTree.prototype.constructor = PageTree;


_.extend( PageTree.prototype, {

    PAGE_NODE_LEVEL: 1,

    /* B/C hits don't have parents ( they would have 2 ) */
    /* I guess could tell from the view */
    getParentOfHitModel: function( hit ) {

        return this.getRoot()
            .getChild( hit.get('pageId') )
            .getChild( hit.get('searchModelId') );

    },

    addHitFromSearch: function( hit, parentNoteOfHit, currentPageNumber ) {

        var root = this.getRoot();
        var pgId = hit.get('pageId');

        if ( !root.getChild( pgId ) ) {

            /**
             * some really odd Backbone shit going on here, when create a new one, it gets the attributes of the previous
             *  _.result(this, 'defaults') --> this.defaults has that of the other and is called in the contructor
             */
            root.addChild( pgId, new PageResult({
                pageId: pgId,
                pageNumber: hit.get('pageNumber'),
                isCurrentPage: currentPageNumber === hit.get('pageNumber'),
                parent: root
            }) );

        }

        var pageSearchResult = root.getChild( pgId );

        var searchId = hit.get('search').cid;

        // TODO: instead of cid create a key for the search from title and order
        // JUST USE CID .. would want searchTerm + searchIndex or search index ... but we don't need to care about
        if ( !pageSearchResult.hasChild( searchId ) ) {

            pageSearchResult.addChild( searchId , new PageSearchResult({
                pageId: pgId,
                note: parentNoteOfHit,
                search: hit.get('search'),
                parent: pageSearchResult
            }));

        }

        pageSearchResult.getChild( searchId ).addChild( hit.id, hit );



    },

    /* just break the link -- child currently in bbone models, ugh ... */
    removeSearch: function( searchId ) {

        _.each( this.getRoot().getChildren(), function(pageNode) {

            delete pageNode.getChildren()[searchId];

            if ( !pageNode.hasChildren() ) {

                delete pageNode.getParent().getChildren()[pageNode.get('pageId')]; // Could have a remove page fn which then goes down recursively for the children
            }


        });


    },

    // TODO: imple maybe depending on validation on search
    getRowModelOfPageNote: function( pageNoteId ) {

        debugger;

    }

});


module.exports = PageTree;




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/pageHierarchy/PageTree.js
 ** module id = 666
 ** module chunks = 0
 **/